<template>
	<div>
<!--		<breadcrumb :routerList="[{to:'/basic/user',title:'系统管理'},{title:'手动跑task'}]"/>-->
    <Breadtabsheader/>
		<div class="h-content">
			<div class="h-piece">
				<div class="el-table el-table--fit el-table--striped el-table--scrollable-x el-table--enable-row-transition">
					<table style="width:100%">
						<tr>
							<td>taskkey</td>
							<td>描述</td>
							<td>操作</td>
						</tr>
						<tr>
							<td>mdmwuliao</td>
							<td>手动同步mdm物料</td>
							<td >
								<el-button size="small" type="success"
										   @click="runtask('mdmService.getConfigByMdmForDay')">mdmService.getConfigByMdmForDay</el-button>
							</td>
						</tr>

						<tr>
							<td>mdmSalesMaterial</td>
							<td>手动同步MDM物料销售信息</td>
							<td >
								<el-button size="small" type="success"
										   @click="runtask('MaterialSalesTask.materialSalesTask')">MaterialSalesTask.materialSalesTask</el-button>
							</td>
						</tr>

						<tr>
							<td>ordersap</td>
							<td>同步sap的订单状态</td>
							<td >
								<el-button size="small" type="success"
										   @click="runtask('orderMainService.getOrderStatus:dn_status')">dn_status：发货状态</el-button>
								<el-button size="small" type="success"
										   @click="runtask('orderMainService.getOrderStatus:ar_status')">ar_status：全部sap状态</el-button>
								<el-button size="small" type="success"
													 @click="runtask('orderCgService.getOrderCode')">采购订单状态</el-button>
							</td>
						</tr>
						<tr>
							<td>ordersap</td>
							<td>同步订单的收货状态</td>
							<td >
								<el-button size="small" type="success"
										   @click="runtask('orderSynService.saveTask')">orderSynService.saveTask</el-button>
								<el-button size="small" type="success"
										   @click="runtask('orderSynDetailService.saveDetailTask')">orderSynDetailService.saveDetailTask</el-button>
							</td>
						</tr>
						<tr>
							<td>creditsap</td>
							<td>更新信贷逾期过期状态</td>
							<td >
								<el-button size="small" type="success"
										   @click="runtask('userInfoCreditService.checkOverdue')">userInfoCreditService.checkOverdue</el-button>
							</td>
						</tr>

						<tr>
							<td>creditsap</td>
							<td>更新导入Excel信息</td>
							<td >
								<el-button size="small" type="success"
										   @click="runtask('flNewTargetService.updateShuju')">flNewTargetService.updateShuju()</el-button>
							</td>
						</tr>

						<tr>
							<td>creditsap</td>
							<td>更新SAP开票信息</td>
							<td >
								<el-button size="small" type="success"
										   @click="runtask('etBillingService.showSapData')">etBillingService.showSapData</el-button>
							</td>
						</tr>

						<tr>
							<td>creditsap</td>
							<td>更新SAP兑现信息</td>
							<td >
								<el-button size="small" type="success"
										   @click="runtask('etZflt019Serivce.showSapData')">etZflt019Serivce.showSapData</el-button>
							</td>
						</tr>

						<tr>
							<td>OrderCaiwuSapChengbenService.tongbuChengben</td>
							<td>同步sap的成本</td>
							<td>
								<el-button size="small" type="success"
										   @click="runtask('OrderCaiwuSapChengbenService.tongbuChengben')">OrderCaiwuSapChengbenService.tongbuChengben</el-button>
							</td>
						</tr>
						<tr>
							<td>creditsap</td>
							<td>手动更新返利产品报表信息</td>
							<td >
								<el-button size="small" type="success"
										   @click="runtask('flXsptCategoryService.selectXsptShuju')">flXsptCategoryService.selectXsptShuju</el-button>
							</td>
						</tr>

						<tr>
							<td>creditsap</td>
							<td>手动执行自动更新采购单付款状态</td>
							<td >
								<el-button size="small" type="success"
										   @click="runtask('bscGemsPayInfoService.updateOrderStatus')">bscGemsPayInfoService.updateOrderStatus</el-button>
							</td>
						</tr>

						<tr>
							<td>creditsap</td>
							<td>手动执行定时任务失败发邮件</td>
							<td >
								<el-button size="small" type="success"
										   @click="runtask('bscTaskRunInfoService.runTaskEmail')">bscTaskRunInfoService.runTaskEmail</el-button>
							</td>
						</tr>

						<tr>
							<td>creditsap</td>
							<td>手动执行海外客户订单跟踪接口</td>
							<td >
								<el-button size="small" type="success"
										   @click="runtask('orderTrackingWaixiaoService.shuju')">orderTrackingWaixiaoService.shuju</el-button>
							</td>
						</tr>

						<tr>
							<td>forecastsap</td>
							<td>手动获取预测相关-Sap生产订单信息</td>
							<td >
								<el-button size="small" type="success"
										   @click="runtask('ObtainYuceTask.selectAllDingd')">ObtainYuceTask.selectAllDingd</el-button>
							</td>
						</tr>

						<tr>
							<td>forecastFinish</td>
							<td>计算本月内销订单对于内销预测的完成度</td>
							<td >
								<el-button size="small" type="success"
										   @click="runtask('YuceReachTask.orderMatching')">YuceReachTask.orderMatching</el-button>
							</td>
						</tr>

						<tr>
							<td>flCashDetail</td>
							<td>返利-手动获取sap返利兑现明细发票数据</td>
							<td >
								<el-button size="small" type="success"
										   @click="runtask('FlCashTask.getFlCash')">FlCashTask.getFlCash</el-button>
							</td>
						</tr>

						<tr>
							<td>vDmManagerService.saveByDayService</td>
							<td>手动获取盈利测算的损益平台数据</td>
							<td >
								<el-button size="small" type="success"
										   @click="runtask('vDmManagerService.saveByDayService')">vDmManagerService.saveByDayService</el-button>
							</td>
						</tr>

						<tr>
							<td>flCashDetailService.saveFlDetail</td>
							<td>返利-手动同步19表数据到cash和detail表</td>
							<td >
								<el-button size="small" type="success"
										   @click="runtask('flCashDetailService.saveFlDetail')">flCashDetailService.saveFlDetail</el-button>
							</td>
						</tr>
						<tr>
							<td>SendToDimUtil.sendToDim</td>
							<td>手动推送定价去DIM系统</td>
							<td >
								<el-button size="small" type="success"
										   @click="runtask('SendToDimUtil.sendToDim')">SendToDimUtil.sendToDim</el-button>
							</td>
              <td style="width: 30%">
                产品编号
                <el-input v-model="materialid" placeholder="请输入"
                          style="width: 50%"></el-input>
                <el-button size="small" type="success"
                           @click="runtaskBtn()">执行
                </el-button>
              </td>
						</tr>
						<tr>
							<td>sapZsdSwylTsTask.sapZsdSwylTs</td>
							<td>手动抓取退税财务凭证</td>
							<td >
								<el-button size="small" type="success"
										   @click="runtask('sapZsdSwylTsTask.sapZsdSwylTs')">sapZsdSwylTsTask.sapZsdSwylTs</el-button>
							</td>
						</tr>
						<tr>
							<td>logisticsInfoInsertUtil.transferOrder</td>
							<td>手动推送订单至售后</td>
							<td >
								<el-button size="small" type="success"
										   @click="runtask('logisticsInfoInsertUtil.transferOrder')">logisticsInfoInsertUtil.transferOrder</el-button>
							</td>
						</tr>

              <tr>
                  <td>WxOrderJiedongTask.sendToSapKaipiao</td>
                  <td>触发Sap解冻开票</td>
                  <td >
                      <el-button size="small" type="success"
                                 @click="runtask('WxOrderJiedongTask.sendToSapKaipiao')">WxOrderJiedongTask.sendToSapKaipiao</el-button>
                  </td>
              </tr>

            <tr>
              <td>getOrderSignToEtBilling</td>
              <td>返利-手动同步返利销额NewEtBilling</td>
              <td >
                <el-button size="small" type="success"
                           @click="runtask('etBillingFromOrderTask.getOrderSignToEtBilling')">etBillingFromOrderTask.getOrderSignToEtBilling</el-button>
              </td>
            </tr>

            <tr>
              <td>getKaOrderSignToEtBilling</td>
              <td>返利-手动同步ka经销商返利销额NewEtBilling</td>
              <td >
                <el-button size="small" type="success"
                           @click="runtask('etBillingFromOrderTask.gatherOrderSignToEtBillingKa')">etBillingFromOrderTask.gatherOrderSignToEtBillingKa</el-button>
              </td>
            </tr>

            <tr>
              <td>gatherGuokeOrderSignToEtBilling</td>
              <td>返利-手动同步国科开票NewEtBilling</td>
              <td >
                <el-button size="small" type="success"
                           @click="runtask('etBillingFromOrderGuokeTask.gatherGuokeOrderSignToEtBilling')">etBillingFromOrderGuokeTask.gatherGuokeOrderSignToEtBilling</el-button>
              </td>
            </tr>
            <tr>
              <td>gatherSerivceSignToFlFxServiceOrder</td>
              <td>返利-手动同步分销商安装量FlFxServiceOrder</td>
              <td >
                <el-button size="small" type="success"
                           @click="runtask('fxsSalesFromServiceTask.gatherSignOrder')">fxsSalesFromServiceTask.gatherSignOrder</el-button>
              </td>
            </tr>
            <tr>
              <td>agentKaohe</td>
              <td>返利-手动执行经销商升降级别</td>
              <td >
                <el-button size="small" type="success"
                           @click="runtask('flAgentKaoheTask.agentKaohe')">flAgentKaoheTask.agentKaohe</el-button>
              </td>
            </tr>
            <tr>
              <td>flAgentKaoheEmailTask.sednAgentKaoheEmail</td>
              <td>返利-季度发送升降级结果邮件</td>
              <td >
                <el-button size="small" type="success"
                           @click="runtask('flAgentKaoheEmailTask.sednAgentKaoheEmail')">flAgentKaoheEmailTask.sednAgentKaoheEmail</el-button>
              </td>
            </tr>
						<tr>
							<td>flGoalSalesBalanceSMSTask.sendSMSMsg</td>
							<td>返利-发送实际目标差额短信</td>
							<td >
								<el-button size="small" type="success"
										   @click="runtask('flGoalSalesBalanceSMSTask.sendSMSMsg')">flGoalSalesBalanceSMSTask.sendSMSMsg</el-button>
							</td>
						</tr>
            <tr>
              <td>GetOrderCGCodeTask.getHHOrderCgNum</td>
              <td>厚宏，元析获取采购收货数量</td>
              <td >
                  <el-button size="small" type="success"
                             @click="runtask('GetOrderCGCodeTask.getHHOrderCgNum')">GetOrderCGCodeTask.getHHOrderCgNum</el-button>
              </td>
             </tr>
					</table>
				</div>
			</div>

		</div>
	</div>
</template>
<script>
   import ss from '../../api/SystemService'
    export default {
        data() {
            return {
                keys:null,
              materialid: null,

            }
        },
        methods: {
            runtask(key){
                this.$msg.confirm("确认提交开跑？",()=>{
                    ss.taskservice.runtaskByKey(key).then(rd=>{
                        this.$msg.alert("提交成功！")
                    })
              })
            },
          runtaskBtn(){
              if(!this.materialid){
                this.$msg.alert("产品编号不能为空！")
              }else{
                this.$msg.confirm("确定执行？", () => {
                  ss.taskservice.runtaskBtn(this.materialid).then(rd => {
                    this.zuofeiSapBtnresult = rd;
                    this.$msg.alert("执行成功！")
                  })
                })
              }
            },
        }
    }
</script>
<style scoped>
.el-button--small, .el-button--small.is-round {
    padding: 3px 5px;
	margin-bottom: 3px
}
</style>
